import { titleize } from '../../utils/helpers';

export const getPageTitle = (page) => {
  if (!page) return '';

  // remove dashes and capitalize each word
  return titleize(page.replace(/_/g, ' '));
};
